$.once = once;

/**
 *
 * @param {function} func
 * @param {object} context
 * @param {array} defaultArgs
 * @returns {function} onced
 */
function once(func, context, ...defaultArgs) {
    /**
     *
     * @type {boolean}
     */
    let isInvoked = false;


    return onced;

    /**
     *
     * @param {array} invokeArgs
     */
    function onced(...invokeArgs){
        if (!isInvoked) {
            func.apply(context || this, defaultArgs.concat(invokeArgs));
        }
    }
}



// WEBPACK FOOTER //
// ./js/main/plugin/once.js